import React from "react";
import BSMLogo from "../assets/bsmLogo.png";
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';
import FacebookIcon from '@mui/icons-material/Facebook';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import MailIcon from '@mui/icons-material/Mail';
import Divider from '@mui/material/Divider';
import './components.css';
import { useTranslation } from "react-i18next";

const FooterComponent = (props) => {
    const { t } = useTranslation();

    return (
        <div className="footer" style={{
            // position: "sticky", bottom: "0"
        }}>
            <div className="footer-social-icons">
            <a href="https://www.instagram.com/bondstreetmortgage/" target="_blank" rel="noopener noreferrer">
                    <InstagramIcon sx={{ fontSize: 25 }} />
                </a>
                <a href="https://www.linkedin.com/company/bond-street-mortgage-llc" target="_blank" rel="noopener noreferrer">
                    <LinkedInIcon sx={{ fontSize: 25 }} />
                </a>
                <a href="https://x.com/BondStreetMtg" target="_blank" rel="noopener noreferrer">
                    <XIcon sx={{ fontSize: 25 }} />
                </a>
                <a href="https://www.facebook.com/BondStreetMortgage/" target="_blank" rel="noopener noreferrer">
                    <FacebookIcon sx={{ fontSize: 25 }} />
                </a>
            </div>
            <Divider className="footer-divider" />
            <div className="footer-contact-info" style={{ fontSize: "small" }}>
            <div className="footer-contact">
                    <FmdGoodIcon sx={{ fontSize: 20 }} /> 
                    <span>{t('115 West Century Road Suite 115 Paramus, NJ 07652')}</span>
                </div>
                <div className="contact-info-divider"></div>
                <div className="footer-contact">
                <a 
                        href="tel:8885885522" 
                        style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}
                    >
                        <LocalPhoneIcon sx={{ fontSize: 20 }} /> 
                        <span style={{ marginLeft: '4px' }}>(888) 588-5522</span>
                    </a>
                </div>
               
                
                <div className="contact-info-divider"></div>
                <div className="footer-contact">
                <a 
                        href="mailto:loaninfo@bondstreetloans.com" 
                        style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center' }}
                    >
                        <MailIcon sx={{ fontSize: 20 }} />
                        <span style={{ marginLeft: '4px' }}>loaninfo@bondstreetloans.com</span>
                    </a>
                </div>
            </div>
            <Divider className="footer-divider" />
            <div className="footer-description">
                {t('Bond Street Mortgage LLC, Mortgage Banker Licensed by the New Jersey Department of Banking and Insurance, NMLS #191351 (www.nmlsconsumeraccess.org). All the information provided is for educational purposes only. Subject to change. Visit us for updates.')}
            </div>
        </div>
    );
}

export default FooterComponent;
